import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { getStoreImageUrl, toStoreImageAltText } from 'lib/image';
import { capitalizeEveryWord } from 'lib/string';

import { useUser } from 'providers/UserProvider';

import APP from 'constants/app';

// serverMonth and serverYear come pre-formatted from getServerSideProps
// to avoid timezone mismatch during client hydration.
const getHeadingText = (isExclusivelyCoupon, storeName, serverMonth) => {
  if (!isExclusivelyCoupon) {
    return `Ofertas e cupons ${storeName}`;
  }

  return `Cupons ${storeName} de ${capitalizeEveryWord(serverMonth || '')}`;
};

const StoreSummary = ({
  isExclusivelyCoupon,
  isStoreVerified,
  serverDateFormatted,
  serverMonth,
  serverYear,
  storeDomain,
  storeImage,
  storeName,
}) => {
  const { isLoggedIn } = useUser();

  return (
    <header className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 lg:gap-x-6">
      <Avatar
        className="row-span-2"
        description={toStoreImageAltText(storeName)}
        icon="store"
        size="size1"
        src={
          storeImage.startsWith(APP.LOCAL_IMAGE_PATH)
            ? storeImage
            : getStoreImageUrl(storeImage, 85)
        }
      />
      <Heading
        as="h1"
        className="col-start-2 max-w-72 text-[22px] lg:max-w-full"
        size="size2"
      >
        {getHeadingText(isExclusivelyCoupon, storeName, serverMonth)}
        {isExclusivelyCoupon && ' '}
        {isExclusivelyCoupon ? (
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            {serverYear || ''}
            {isStoreVerified && <Icon name="verified-color" size="size3" />}
          </span>
        ) : (
          isStoreVerified && (
            <span className="ml-1 inline-flex items-center">
              <Icon name="verified-color" size="size3" />
            </span>
          )
        )}
      </Heading>
      {storeDomain && (
        <Text className="col-start-2 row-start-2 text-neutral-high-500">
          {storeDomain}
        </Text>
      )}
      {isExclusivelyCoupon && !isLoggedIn && (
        <Text
          className="col-start-2 row-start-3 text-neutral-high-500"
          size="size1"
        >
          Atualizado em {serverDateFormatted}
        </Text>
      )}
    </header>
  );
};

StoreSummary.propTypes = {
  isExclusivelyCoupon: PropTypes.bool,
  isStoreVerified: PropTypes.bool.isRequired,
  serverDateFormatted: PropTypes.string,
  serverMonth: PropTypes.string,
  serverYear: PropTypes.number,
  storeDomain: PropTypes.string,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};

export default StoreSummary;
